import { analytics } from '../analytics';
import { MOVE_CARD } from '../../../_redux/workflow/actions/actions';
import { createMiddleware } from '../../../../shared/redux';

export const workflowMiddleware = createMiddleware({
    [MOVE_CARD]: async (_, { card, column }) => {
        await analytics.track('card_moved', {
            provider: card.provider,
            status: column,
            previousStatus: card.status,
            cardId: card.id,
            clientId: card.client?.id,
            accountId: card.account?.id,
            teamId: card.team,
            controlType: card.control_type,
        });
    },
}, { beforeChanges: true });
